import { render, staticRenderFns } from "./InformationHover.vue?vue&type=template&id=953de53a&scoped=true&"
import script from "./InformationHover.vue?vue&type=script&lang=js&"
export * from "./InformationHover.vue?vue&type=script&lang=js&"
import style0 from "./InformationHover.vue?vue&type=style&index=0&id=953de53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953de53a",
  null
  
)

export default component.exports